import type { RootState } from 'state';
import type { DataCitiesState } from '../slice';

function getDataCities(state: RootState): DataCitiesState['value'] {
  const { value } = state.dataService.dataCities;
  return value;
}

export default getDataCities;
